module.exports = __webpack_public_path__ + "static/img/anxun7.f3893b71.png";